import "./styles/legal.css";

function Privacy() {
  return (
    <main className="legal-page">

      <div className="legal-container">

        <span className="legal-label">
          Legal
        </span>

        <h1>Privacy Policy</h1>

        <p className="legal-subtitle">
          Transparency and trust are important to every professional
          relationship. This Privacy Policy explains what information may be
          collected through joelgeorge.dev, how it is used, and the steps taken
          to protect it.
        </p>

        <p className="last-updated">
          Last Updated: August 5, 2026
        </p>

        {/* Personal Note */}

        <section>

          <h2>A Personal Note</h2>

          <p>
            Every inquiry submitted through this website is reviewed by me
            personally. I don't believe in collecting unnecessary personal
            information, selling visitor data, or filling inboxes with unwanted
            emails.
          </p>

          <p>
            If you decide to contact me, your information is used solely for
            professional communication regarding your project, employment
            opportunity, collaboration, or enquiry.
          </p>

        </section>

        {/* Information */}

        <section>

          <h2>Information Collected</h2>

          <p>
            Depending on how you interact with this website, the following
            information may be collected:
          </p>

          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Company or organization (optional)</li>
            <li>Project details or enquiry information</li>
            <li>Website or LinkedIn profile (optional)</li>
            <li>Budget and project timeline (optional)</li>
          </ul>

          <p>
            Only the information you voluntarily submit through the contact
            form is collected.
          </p>

        </section>

        {/* Usage */}

        <section>

          <h2>How Your Information Is Used</h2>

          <p>Your information may be used to:</p>

          <ul>
            <li>Respond to enquiries and messages.</li>
            <li>Discuss freelance projects or consulting opportunities.</li>
            <li>Review recruitment opportunities.</li>
            <li>Prepare quotations and project proposals.</li>
            <li>Maintain communication throughout an active project.</li>
          </ul>

          <p>
            Personal information is never sold, rented, or shared for
            advertising purposes.
          </p>

        </section>

        {/* Principles */}

        <section>

          <h2>Privacy Principles</h2>

          <div className="legal-grid">

            <div className="legal-card">
              <h3>Minimal Collection</h3>
              <p>
                Only information required to respond professionally is
                requested.
              </p>
            </div>

            <div className="legal-card">
              <h3>No Data Selling</h3>
              <p>
                Personal information is never sold or shared with marketing
                companies.
              </p>
            </div>

            <div className="legal-card">
              <h3>Secure Storage</h3>
              <p>
                Reasonable technical safeguards are implemented to protect
                submitted information.
              </p>
            </div>

            <div className="legal-card">
              <h3>Transparency</h3>
              <p>
                If the way data is collected or processed changes
                significantly, this policy will be updated accordingly.
              </p>
            </div>

          </div>

        </section>

        {/* Data Flow */}

        <section>

          <h2>How Your Information Flows</h2>

          <div className="flow-container">

            <div className="flow-item">
              You
            </div>

            <span>↓</span>

            <div className="flow-item">
              Secure Contact Form
            </div>

            <span>↓</span>

            <div className="flow-item">
              Secure Backend
            </div>

            <span>↓</span>

            <div className="flow-item">
              Protected Database
            </div>

            <span>↓</span>

            <div className="flow-item">
              Joel George
            </div>

          </div>

        </section>

        {/* Tech */}

        <section>

          <h2>Infrastructure</h2>

          <p>
            This portfolio is built using modern technologies and trusted cloud
            services.
          </p>

          <ul>
            <li>Frontend — React</li>
            <li>Backend — Node.js & Express</li>
            <li>Database — MongoDB Atlas</li>
            <li>Email Delivery — SMTP</li>
            <li>Automation — n8n</li>
            <li>Version Control — GitHub</li>
            <li>Hosting — Render / Cloud Infrastructure</li>
          </ul>

        </section>

        {/* AI */}

        <section>

          <h2>Artificial Intelligence</h2>

          <p>
            AI-assisted tools may occasionally be used to improve productivity
            during research, documentation, testing, brainstorming, or software
            development.
          </p>

          <p>
            Every deliverable is personally reviewed, validated, and customized
            before being shared with clients.
          </p>

        </section>

        {/* Confidentiality */}

        <section>

          <h2>Confidentiality</h2>

          <p>
            Client discussions frequently involve confidential business ideas,
            product concepts, or technical requirements.
          </p>

          <p>
            Information shared through this website or during project
            discussions is treated confidentially unless disclosure is required
            by law or explicit written permission has been provided.
          </p>

        </section>

        {/* Cookies */}

        <section>

          <h2>Cookies & Analytics</h2>

          <p>
            This website may use cookies or basic analytics tools to understand
            website usage, improve performance, and enhance the visitor
            experience.
          </p>

          <p>
            These tools are never used to identify individual visitors for
            advertising purposes.
          </p>

        </section>

        {/* Retention */}

        <section>

          <h2>Data Retention</h2>

          <p>
            Enquiry information is retained only for as long as reasonably
            necessary to provide support, complete projects, or maintain
            professional communication.
          </p>

        </section>

        {/* Rights */}

        <section>

          <h2>Your Rights</h2>

          <p>
            You may request access to, correction of, or deletion of your
            personal information at any time by contacting me directly.
          </p>

        </section>

        {/* Contact */}

        <section>

          <h2>Questions?</h2>

          <p>
            If you have any questions regarding this Privacy Policy or how your
            information is handled, feel free to get in touch.
          </p>

          <p>

            <strong>Email</strong>

            <br />

            contact@joelgeorge.dev

          </p>

          <p>
            Thank you for taking the time to read this policy and for visiting
            my portfolio.
          </p>

        </section>

      </div>

    </main>
  );
}

export default Privacy;